module.exports = __webpack_public_path__ + "media/nivel3.4b855478.png";